





























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Accordion } from '@/pages/profile/components';
import {
  MentoringCrew,
  MentoringTeamCardMentor,
  MentoringFooterItem,
} from './components';
import { MentoringCardFooter } from '@/pages/profile/modules/mentoring/components';
import { pluralizeMembers } from '@/tools/pluralize';
import { Child, Crew, Mentor, IMentoringTeamCard } from './types';

@Component({
  components: {
    MentoringCrew,
    Accordion,
    MentoringCardFooter,
    MentoringFooterItem,
    MentoringTeamCardMentor,
  },
})
export default class MentoringTeamCard extends Vue
  implements IMentoringTeamCard {
  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  @Prop({ type: String, default: '' })
  readonly title!: string;

  @Prop({ type: Object, default: () => {} })
  readonly curator!: Mentor;

  @Prop({ type: Object, default: () => {} })
  readonly mentor!: Mentor;

  @Prop({ type: Array, default: () => [] })
  readonly crew!: Crew;

  @Prop({ type: Object, default: () => {} })
  readonly child!: Child;

  public opened: boolean = this.index === 0;

  get footerUserCountText(): string {
    return pluralizeMembers((this.crew.length + 3).toString());
  }

  get buttonText(): string {
    return this.opened ? 'Свернуть' : 'Развернуть';
  }

  toggle(): void {
    this.opened = !this.opened;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/teamcard/MentoringTeamCard.vue